// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"487":"myOrder","962":"home"}[chunkId] + "." + {"487":"ae308697","962":"ba4f4b3b"}[chunkId] + ".css";
};